// extracted by mini-css-extract-plugin
export var growableInput = "_8w-0";
export var tagContainer = "_8w-2";
export var textInput = "_8w-1";